export default {
  tableFields: [
    {
      name: 'SETTLEMENT ID',
      sortField: 'SETTLEMENT ID',
      width: '10%',
    },
    {
      name: 'CREATE DATE',
      sortField: 'CREATE DATE',
      width: '10%',
    },
    {
      name: 'START DATE',
      sortField: 'START DATE',
      width: '7%',
    },
    {
      name: 'END DATE',
      title: 'END DATE',
      width: '7%',
    },
    {
      name: 'ORDER AMOUNT',
      title: 'ORDER AMOUNT',
      width: '8%',
    },   
    {
      name: 'PAYOUT AMOUNT',
      title: 'PAYOUT AMOUNT',
      width: '9%',
    },
    {
      name: 'PAYOUT DATE',
      title: 'PAYOUT DATE',
      width: '8%',
    },
    {
      name: 'PAYOUT STATUS',
      title: 'PAYOUT STATUS',
      width: '9%',
    },
    {
      name: 'REPORT',
      title: 'REPORT',
      dataClass: 'text-center',
      width: '4%'
    },
  ],
  sortFunctions: {
    'name': function (item1, item2) {
      return item1 >= item2 ? 1 : -1
    },
    'email': function (item1, item2) {
      return item1 >= item2 ? 1 : -1
    },
  },
}


 /* {
      name: 'CHARGEBACK & REFUND ADJUSTMENT',
      title: 'CHARGEBACK & REFUND ADJUSTMENT',
      width: '17%',
    }, */
    /* {
      name: 'TOTAL SERVICE FEE',
      title: 'TOTAL SERVICE FEE',
      width: '9%',
    }, */